export const GET_RESERVATION_TYPES = 'GET_RESERVATION_TYPES'
export const GET_ISSUES = 'GET_ISSUES'
export const GET_MATCHER = 'GET_MATCHER'
export const GET_MATCHER_FOR_DISPLAY = 'GET_MATCHER_FOR_DISPLAY'
export const ERRORS_PRESENT = 'ERRORS_PRESENT'
export const GET_PERMISSION_TO_SEND = 'GET_PERMISSION_TO_SEND'
export const GET_DATE_TIME_FORMAT = 'GET_DATE_TIME_FORMAT'
export const GET_SELECTED_TZ = 'GET_SELECTED_TZ'
export const GET_ERRORS = 'GET_ERRORS'
